import { Component, OnInit, Optional, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContentService } from '../../content.service';
import { BehaviorSubject, of, Observable } from 'rxjs';
import { Page } from 'projects/f-cms/src/app/models/page';
import { skip, take } from 'rxjs/operators';
import { CreatePageService } from '../../create-page/create-page.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ContentMenu } from 'projects/f-cms/src/app/interfaces/contentMenu';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';

@Component({
  selector: 'app-page-actions-dialog',
  templateUrl: './page-actions-dialog.component.html',
  styleUrls: ['./page-actions-dialog.component.scss']
})
export class PageActionsDialogComponent implements OnInit {

  @Input('picked$') picked$: BehaviorSubject<Page[]> = new BehaviorSubject([]);
  @Input('treeControl') treeControl = new NestedTreeControl<Page>(node => node.pages)
  dataSource = new MatTreeNestedDataSource<Page>();

  type: 'copy' | 'move' | 'import'
  copyHomepage = new UntypedFormControl(null, [Validators.required]);
  itemSelected: ContentMenu;
  maxPages = 1;
  fromId: any;
  itemSelectedType: 'HOMEPAGE' | 'PAGE';
  messageStatus: string;
  messageText: string;
  fromPage: Page = {} as Page;
  itemType: 'HOMEPAGE' | 'PAGE';
  isPageSolo: boolean;
  workflowOnGoingPages: any[];
  itemSelectedId: string;
  menuId: string;
  itemSelectedMenuId: string;


  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PageActionsDialogComponent>,
    private contentService: ContentService,
    private pageService: CreatePageService,
    private messageService: MessageService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.type = this.data.type;
    this.fromId = this.data.id;
    this.itemType = this.data.itemType;
    this.isPageSolo = !this.data.hasInternalPages;
    this.menuId = this.data.menuId
    console.log(this.data)
  }

  subscribeToSelectedPage() {
    this.picked$.pipe(skip(1)).subscribe(pages => this.selectWhereTo(pages))
  }

  selectWhereTo(pages: Page[]): void {
    let item = pages[0];

    if (item) {
      console.log({ item })
      this.itemSelected = item;
      if (item.homePageParent) {
        this.itemSelectedType = 'PAGE';
        this.itemSelectedId = this.itemSelected.id;
        this.itemSelectedMenuId = this.itemSelected.menuId;
      } else {
        this.itemSelectedType = 'HOMEPAGE';
        this.itemSelectedId = this.itemSelected.homePageId;
      }
    }
  }

  send() {

    let pageAction$: Observable<any>
    this.messageStatus = undefined;
    this.workflowOnGoingPages = [];

    switch (this.type) {
      case 'move':
        pageAction$ = this.contentService.movePage(this.fromId, this.itemSelectedId, this.itemSelectedType)
        break;
      case 'copy':
        pageAction$ = this.itemType == 'HOMEPAGE' ? this.contentService.copyHomepage(this.fromId, this.copyHomepage.value) : this.contentService.copyPage(this.fromId, this.itemSelectedId, this.itemSelectedType)
        break;
      case 'import':
        pageAction$ = this.contentService.importPage(this.fromId, this.itemSelectedId, this.itemSelectedType);
        break;
      default:
        pageAction$ = of(false)
        break;
    }

    pageAction$.subscribe(resp => this.validateResponse(resp), err => this.valError(err))
  }

  validateDisabled() {
    if (this.type === 'copy') {
      return this.itemType == 'HOMEPAGE' ? this.copyHomepage.invalid : false;
    }
  }

  valError(err: any): void {
    if (err.status == 422) {

      if (typeof err.error == "string") {
        this.setMessage('error', err.error, '')
      } else if (err.error && err.error.message == 'duplicate title') {
        this.setMessage('error', this.translateService.instant(`dialogs.pageActions.${this.type}.duplicateError${this.itemType}`), '')
      } else if (err.error && err.error.workflowOnGoing) {
        this.setMessage('error', this.translateService.instant(`dialogs.pageActions.${this.type}.workflowOnGoing${this.isPageSolo ? 'Solo' : ''}`), '')
        this.workflowOnGoingPages = err.error.workflowOnGoing;

      } else if (err.error && err.error.target) {

        if (err.error.target == "this page is already in this homepage")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.pageAlreadyInHomepage`), '')
        else if (err.error.target == "this page is already in this page")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.pageAlreadyInThisPage`), '')
        else if (err.error.target == "target cannot be subPage of page")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.pageCannotBeSubpage`), '')
        else if (err.error.target == "target homepage not found")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.homePageNotFound`), '')
        else if (err.error.target == "target page not found")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.pageNotFound`), '')
        else if (err.error.target == "this page is already in the target page's hierarchy")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.pageAlreadyInHierarchy`), '')
        else if (err.error.target == "It is not allowed to move to an imported page")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.pageInImportedPage`), '')
        else if (err.error.target == "The import of an already imported page is not permitted.")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.moveImportedPageNotPermitted`), '')
        else if (err.error.target == "It is not allowed to import to the same homepage")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.pageAlreadyInHomepage`), '')
        else if (err.error.target == "Operation not permitted")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.operationNotPermitted`), '')
        else if (err.error.target == "The destination and source pages are identical")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.pagesAreIdentical`), '')
        else if (err.error.target == "Error creating SubPage")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.errorCreatingSubpage`), '')
        else if (err.error.target == "SubPage not found")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.subpageNotFound`), '')
        else if (err.error.target == "Menu item not found")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.menuItemNotFound`), '')
        else if (err.error.target == "Error when trying to import the pages")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.tryngImportPages`), '')
        else if (err.error.target == "Menu not found")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.menuNotFound`), '')
        else if (err.error.target == "Invalid move type.")
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.invalidMoveType`), '')
        else
          this.setMessage('error', this.translateService.instant(`dialogs.pageActions.pageAlreadyInHomepage`), '')

      }
    } else if (err.status == 400 && !err.error) {
      this.setMessage('error', this.translateService.instant(`dialogs.pageActions.${this.type}.workflowOnGoing${this.isPageSolo ? 'Solo' : ''}`), '')
    } else {
      this.setMessage('error', this.translateService.instant(`dialogs.pageActions.${this.type}.errorSended`), '')
    }
  }

  showPageList() {
    switch (this.type) {
      case 'move':
        return true
      case 'copy':
        return this.itemType == 'PAGE'
      case 'import':
        return true
      default:
        break;
    }
  }

  validateResponse(resp: any) {
    let summary;

    switch (this.type) {
      case 'move':
        summary = this.translateService.instant(`dialogs.pageActions.${this.type}.actionExecuted`);
        break;
      case 'copy':
        summary = this.translateService.instant(`dialogs.pageActions.${this.type}.${this.itemType}.actionExecuted`);
        break;
      case 'import':
        summary = this.translateService.instant(`dialogs.pageActions.${this.type}.${this.itemType}.actionExecuted`)
      default:
        break;
    }

    let detail = this.itemSelected ? this.itemSelected.title : '';

    this.messageService.add({ severity: 'success', summary, detail })
    this.close();
  }

  // setMessage(type: string, message: string): void {
  //   this.messageStatus = type;
  //   this.messageText = message;
  // }

  setMessage(severity: string, summary: string, detail: string): void {
    this.messageService.add({ severity, summary, detail })
  }

  close() {
    this.dialogRef.close();
  }
}
